import { GrouperServiceConverter } from 'src/services/converters/GrouperServiceConverter';
import { AxiosService } from 'src/services/AxiosService';
import {AnalyseCode} from 'src/contracts/drgAnalyseResponseDto';
import {DrgAnalysisCode} from 'src/contracts/drgAnalysis';
import { CodeType } from 'src/contracts/codeType';

/**
 * Service for interacting with the backend Grouper V3 service.
 */
export class SearchService extends AxiosService {

  async searchCodes(token: string, codeType: CodeType): Promise<DrgAnalysisCode[]> {
    const result =  await this.axiosCall<AnalyseCode[]>({
      method: 'get',
      url: `/grouper/search/${this.visitId}/${encodeURIComponent(codeType === CodeType.Diagnosis ? 'DIAGNOSIS' : 'PROCEDURE')}?token=${encodeURIComponent(token)}`,
    });

    if (result.err) {
      console.log(`[GrouperService] Error: ${(<Error>result.err).message}`);
      throw new Error((<Error>result.err).message);
    }

    return <DrgAnalysisCode[]>GrouperServiceConverter.convertCodes(<AnalyseCode[]>result.data);
  }
}

